import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <section className="max-w-3xl mx-auto px-6 py-32 text-center">
    <span className="sep-lotus mb-6 justify-center">A gentle pause</span>
    <h1 className="font-serif text-5xl md:text-6xl text-[#3d2817]">This path leads elsewhere.</h1>
    <p className="mt-6 text-lg text-[#5a4a3a]">The page you were looking for isn’t here — but there’s tea back at the entrance.</p>
    <Link to="/" className="btn-primary mt-10">Return home</Link>
  </section>
);

export default NotFound;
